import React from "react";
import { TooltipTheOneWrapper } from "../TooltipTheOne";
import { getIconName, iconName } from "../icons/Icons";
import { IconWrapper, StyledButton } from "../styles/button2Styles";
import { ButtonFontSize, ButtonSize, ButtonVariant } from "./Shared";

type ButtonType = 'button' | 'submit' | 'reset';


export type ButtonVariantStyles = {
    default: ButtonVariantStateStyles,
    hover: ButtonVariantStateStyles,
    active: ButtonVariantStateStyles,
    disabled: ButtonVariantStateStyles,
}

export type ButtonVariantStateStyles = {
    border:string,
    background:string,
    color:string
}


export type ButtonProps = {
    ariaLabel?:string;
    dataCy?:string;
    disabled?: boolean;
    emphasize?:boolean;
    fontSize?: ButtonFontSize;
    icon?: iconName;
    iconPosition?: 'left' | 'right';
    innerRef?:React.Ref<HTMLButtonElement>;
    onClick?:React.MouseEventHandler<HTMLButtonElement>
    size?:ButtonSize;
    text?: string;
    titleText?:string;
    toolTipText?:string;
    tooltipContent?:React.ReactNode;
    tooltipHorizontalAlignment?: 'left' | 'right';
    type?:ButtonType;
    variant:ButtonVariant;
    marginBottom?:string;
    className?:string;
}
export function Button(props: ButtonProps){

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            props.onClick && props.onClick(event);  // Trigger the onClick function when Enter is pressed and pass the event object as an argument
        }
      };

    const className = props.className 
        ? `button2 ${props.className}`
        : "button2";
    
    const btn =
        <StyledButton
            data-cy={props.dataCy}
            onKeyDown={handleKeyDown}    
            title={props.titleText}
            ref={props.innerRef}
            variant={props.variant}
            icon={props.icon}
            iconPosition={props.iconPosition}
            disabled={props.disabled}
            size={props.size}
            fontSize={props.fontSize}
            hasText={!!props.text}
            aria-label={props.ariaLabel}
            onClick={ (e) => props.onClick!=undefined && props.onClick(e)}
            className={className}
            emphasize={props.emphasize}
            style={{ marginBottom: props.marginBottom }}
            >    
        
            {props.icon && (
                <IconWrapper variant={props.variant} size={props.size} emphasize={props.emphasize} disabled={props.disabled}>{getIconName(props.icon)}</IconWrapper>
            )}
            {props.text && (
                <span>{props.text}</span>
            )}
        </StyledButton>;

    return (
        <>
            {props.toolTipText 
                ?   <TooltipTheOneWrapper tooltipContent={props.toolTipText} horizontalAlignment={props.tooltipHorizontalAlignment}>
                        {btn}
                    </TooltipTheOneWrapper>
                : btn
            }
        </>
    );
}


